import { DateTime } from 'luxon';

import { isObject } from './object';

function isDate(value: unknown): value is Date {
  return isObject(value) && value.constructor === Date;
}

function isDateTime(value: unknown): value is DateTime {
  return isObject(value) && value.constructor === DateTime;
}

export { DateTime, isDate, isDateTime };
